import { Grid2, Tooltip } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import { substringText } from '../../../utils/StringUtil'
import { getText } from '../../../utils/VigilanceUtil'
import DtoVigilance from '../../dto/DtoVigilance'

const VigilanceCard = ({
    vigilance,
    smallCard = false,
    containerStyle = {},
}) => (
    <Grid2
        container
        size={12}
        className={`${smallCard ? 'border-bottom-light' : ''}`}
        sx={!smallCard ? {
            width: '80%',
            margin: 'auto',
            marginTop: '50px',
            marginBottom: '36px',
            borderRadius: '2px',
            boxShadow: '0px 5px 8px rgb(0 0 0 / 8%) !important',
            transition: 'transform 0.25s ease-in-out !important',
            '&:hover': {
                transform: 'scale(1.05)',
            },
            ...containerStyle,
        } : containerStyle}
    >
        <Tooltip
            placement='top-start'
            arrow
            slotProps={{
                popper: { disablePortal: true },
            }}
            title={vigilance.texts && substringText(getText(vigilance.texts))}
        >
            <>
                <Grid2 container size='auto' alignItems='center'>
                    <img src={vigilance.url} alt='vigilanceImage' width='auto' style={{ height: '2.5rem' }} />
                </Grid2>
                <Grid2 container size={10} className={`white ${smallCard ? 'padding-left-2' : ''}`} sx={{ padding: `${!smallCard ? '0 0.75rem' : ''}` }}>
                    <Grid2 size={12}>
                        {!smallCard && (
                            <h4 className='clickable bold' style={{ marginTop: '1rem', fontSize: '2rem' }} >{`${vigilance.info} - ${vigilance.locationName} (${vigilance.locationCode})`}</h4>
                        )}
                        {smallCard && (
                            <b className='bold'>{`${vigilance.info} - ${vigilance.locationName} (${vigilance.locationCode})`}</b>
                        )}
                    </Grid2>
                    <Grid2 size={12}>
                        {!smallCard && (
                            <h6 className='clickable' style={{ marginBottom: '1rem' }} >{`${i18n.fromDate} ${vigilance.start} ${i18n.to} ${vigilance.end}`}</h6>
                        )}
                        {smallCard && (
                            <span>{`${i18n.fromDate} ${vigilance.start} ${i18n.to} ${vigilance.end}`}</span>
                        )}
                    </Grid2>
                </Grid2>
            </>
        </Tooltip>
    </Grid2>
)

VigilanceCard.propTypes = {
    vigilance: PropTypes.instanceOf(DtoVigilance),
    smallCard: PropTypes.bool,
    containerStyle: PropTypes.shape({}),
}

export default VigilanceCard
